var map;
var mark = {lat: 53.3376, lng: 83.6840};
var TabletResize = 950;
var PhoneResize = 450;
$(window).resize(function () {
    initMap()
});
function initMap() {
    if ($('div').is("#map") != true) {
        return false
    }

    var $map = $('#map'),
        coord = {
           lat: Number($map.data('lat')),
           lon: Number($map.data('lon')),
           center_lat: Number($map.data('center-lat')),
           center_lon: Number($map.data('center-lon'))
        };


    var WidthWindow = $(window).width();
    if (WidthWindow > TabletResize) {
        map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: coord.center_lat, lng: coord.center_lon},
            zoom: 17,
            scrollwheel: false,
            disableDefaultUI: true
        });
    }
    else if (WidthWindow > PhoneResize) {
        map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: coord.lat, lng: coord.lon},
            zoom: 16,
            scrollwheel: false,
            disableDefaultUI: true
        });
    }
    else {
        map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: coord.lat, lng: coord.lon},
            zoom: 12,
            scrollwheel: false,
            disableDefaultUI: true
        });
    }

    if($map.data('club-code') != 'vzlet'){
        var image = {
            url: $map.data('pin'),
            size: new google.maps.Size(48, 60),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(48, 60)
        };

        var Marker = new google.maps.Marker({
            position: {lat: coord.lat, lng: coord.lon},
            map: map,
            icon: image,
            title: 'Магис на взлетной'
        });
    }


}
